import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5a015304"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "box card"
}
const _hoisted_2 = {
  key: 1,
  class: "animate box card"
}
const _hoisted_3 = { class: "img animate" }
const _hoisted_4 = {
  key: 0,
  width: "350"
}
const _hoisted_5 = {
  key: 1,
  class: "mobile-img"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "span"
}
const _hoisted_8 = { class: "buttons-container" }
const _hoisted_9 = { class: "buttons-place" }
const _hoisted_10 = { class: "pro" }

import { ref, onMounted } from 'vue'
import FollowCourseWidget from '../widgets/FollowCourseWidget.vue'
import CourseProgressbar from '../widgets/CourseProgressbar.vue';
import router from '@/router'
import useWindowWidth from '@/composables/useWindowWidth'
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseList',
  props: ['content', 'showOrder'],
  setup(__props) {

const {windowWidth} = useWindowWidth()

const props = __props
const card = ref({
    id: 0,
    name: 'cargando...',
    description: 'cargando...',
    order: 0,
    image_url: 'img/lms/loading.png',
    roadmap_id: 0,
    created_at: '',
    updated_at: ''
})
const loading = ref(true)

onMounted(() => {
    loading.value = true
    card.value = props.content
    loading.value = false
})

const handleRoute = () => router.push({name: 'course', params: {id: card.value.id}})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "ri-loader-2-fill",
          animation: "spin",
          class: "icon"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(windowWidth) > 950)
            ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_4, null, 512)), [
                [_directive_lazy, { src: props.content.imageURL, loading: '../../../img/lms/loading.png' }]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_5, null, 512)), [
                [_directive_lazy, { src: props.content.imageURL, loading: '../../../img/lms/loading.png' }]
              ])
        ]),
        _createElementVNode("h3", {
          class: "clickable",
          onClick: handleRoute
        }, [
          _hoisted_6,
          (props.showOrder == 'true')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "#" + _toDisplayString(props.content.order), 1))
            : _createCommentVNode("", true),
          _createTextVNode(_toDisplayString(props.content.name), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(FollowCourseWidget, {
              courseId: card.value.id
            }, null, 8, ["courseId"]),
            _createElementVNode("button", { onClick: handleRoute }, [
              _createVNode(_component_v_icon, {
                name: "bi-arrow-right-circle-fill",
                fill: _unref(main).THIRD_COLOR,
                hover: "true",
                animation: "wrench",
                class: "heart",
                scale: "1"
              }, null, 8, ["fill"]),
              _createTextVNode("Acceder")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(CourseProgressbar, {
            courseId: props.content.id
          }, null, 8, ["courseId"])
        ])
      ]))
}
}

})